import CourseDetailsSection from "~/components/pages/courses/course-details-section";
import type { Route } from "./+types/course"
import BreadcrumbSection from "~/layout/public/bread-crumbs/bread-crumb-section";
import { createSignedFormRef } from "~/utils/form-signing";
import { canonical, getTitleTemplate } from "~/utils/meta";
import { useCoursesData } from "./layout";
import { formatSlugTitle } from "~/utils/strings";
import { getOgImage } from "~/utils/get-og-image";
import { defaultMeta, mergeMeta } from "~/lib/meta";
import { redirect, type LoaderFunctionArgs } from 'react-router';


const COURSE_SLUG_REDIRECTS: Record<string, string> = {
  '2-day-supervising-first-aid-for-mental-health': 'level-3-supervising-mhfa',
  'epilepsy-train-the-trainer': 'epilepsy-train',
  'f-someone-collapses-cpr-aed-before-ambulance-arrives': 'if-someone-collapses-cpr-aed-before-ambulance-arrives'
};

export async function loader({ params }: LoaderFunctionArgs) {
  const { category, courseId } = params;

  console.log('Loader params:', params); // Debugging log

  const newSlug = COURSE_SLUG_REDIRECTS[courseId ?? ''];
  console.log('Redirecting to new slug:', newSlug); // Debugging log
  if (newSlug) {
    return redirect(`/courses/${category}/${newSlug}`, 301);
  }


  const formRef = "quick-contact";           // page-specific
  const formSig = createSignedFormRef(formRef, process.env.FORM_TIMEOUT ? Number(process.env.FORM_TIMEOUT) : 1800); // 30 minute expiry
  return { formRef, formSig };
}




export default function CoursesCourse({ loaderData }: Route.ComponentProps) {
  let bcTitle = 'Courses';
  let bcText = '<span class="bcSubTitle">Training Designed for You</span><br />Beyond industry standards, we customise courses to meet your specific needs.';
  const { courseDetails } = useCoursesData();
  bcTitle = courseDetails?.name ?? bcTitle;
  bcText = courseDetails?.seoDescription ?? bcText;

  return (
    <>
      <BreadcrumbSection title={bcTitle} text={bcText} />
      <CourseDetailsSection />
    </>
  );
}

export function meta({ matches, params }: Route.MetaArgs) {
  const { courseDetails } = useCoursesData();
  const tpl = getTitleTemplate(matches);
  const courseName =
    (courseDetails?.name as string | undefined) ??
    (params.courseId ? formatSlugTitle(params.courseId) : "Course");

  const title = tpl(courseName);
  const desc = courseDetails?.seoDescription ?? `Details for ${courseName} from Constellation Training.`;

  const tags = courseDetails?.tags ?? [];
  const slug = tags[0].reference ?? params.ctid;
  const url = canonical(`/courses/${slug ?? ""}/${params.courseId ?? ""}`);
  const image = getOgImage(courseDetails?.largeImage ?? "https://constellationtraining.co.uk/img/social/social-share-default.jpg");

  return mergeMeta(
    defaultMeta(),
    [
      { title: title },
      { name: "description", content: desc },
      { property: "og:title", content: title },
      { property: "og:description", content: desc },
      { property: "og:image", content: image },
      { property: "og:url", content: url },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: desc },
      { name: "twitter:image", content: image },
      { tagName: "link", rel: "canonical", href: url },
      // add canonical as a <link> via your links() export separately
    ]
  );
}